export default {
  methods: {
    /**
     * Send user to 404 page which will auto-redirect to given route.
     * @param {string|object} redirect Route to redirect from 404 page.
     */
    $_redirectHandler_404(redirect) {
      this.$router.replace({ name: '404', params: { redirect } })
    },
  },
}
